export { GoogleAnalytics } from "./gtag";
